import AnalyticsWebClient from '@atlassiansox/analytics-web-client/client';
import { originType } from '@atlassiansox/analytics-web-client/analytics-web-types';

export const client: AnalyticsWebClient = new AnalyticsWebClient({
	product: 'csm',
	subproduct: 'widget',
	version: process.env.PACKAGE_VERSION,
	env: process.env.CAWI_ENV || 'staging',
	origin: originType.WEB,
});
